export { default } from './SectionSponsor';